module.exports = __webpack_public_path__ + "static/img/ICBC.92783217.png";